import { render, staticRenderFns } from "./termsAndConditionsTemplate.vue?vue&type=template&id=56aeb7bb"
import script from "./termsAndConditionsTemplate.vue?vue&type=script&lang=js"
export * from "./termsAndConditionsTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports